
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface TimelineFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  interactionCounts: { [key: string]: number };
}

export const TimelineFilters: React.FC<TimelineFiltersProps> = ({
  activeFilter,
  onFilterChange,
  interactionCounts
}) => {
  const filterTypes = [
    { value: 'all', label: 'All' },
    { value: 'email', label: 'Emails' },
    { value: 'call', label: 'Calls' },
    { value: 'meeting', label: 'Meetings' },
    { value: 'note', label: 'Notes' },
  ];

  return (
    <Tabs value={activeFilter} onValueChange={onFilterChange}>
      <TabsList className="grid w-full grid-cols-5">
        {filterTypes.map(type => (
          <TabsTrigger key={type.value} value={type.value} className="text-xs">
            {type.label} ({interactionCounts[type.value] || 0})
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
